export default __webpack_public_path__ + "static/anchors-for-headings-in-mdx-f2ae8f5bca8909f8d1992e751d01ee69.svg";